import vue from 'vue';

import Clist from './Clist.vue';
import CPortada from './Portada.vue';
import Cbarra from './Cbarra.vue';
import Info from './Infografia.vue';
import Enlaces from './Enlaces.vue';
import Acordeon from './Acordeon.vue';
import Carrusel from './Carrusel.vue';
import Directorio from './Directorio.vue';
import Texto from './Texto.vue';
import Tabla from './Tabla.vue';
import Imagenes from './Imagenes.vue';



vue.component('Clist', Clist);
vue.component('CPortada', CPortada);
vue.component('Cbarra', Cbarra);
vue.component('CInfo', Info);
vue.component('CEnlaces', Enlaces);
vue.component('CAcordeon', Acordeon);
vue.component('CDirectorio', Directorio);
vue.component('CCarrusel', Carrusel);
vue.component('CTexto', Texto);
vue.component('CTabla', Tabla);
vue.component('CImagenes', Imagenes);


